import { render, staticRenderFns } from "./CombinedButton.vue?vue&type=template&id=a397fd64&"
import script from "./CombinedButton.vue?vue&type=script&lang=ts&"
export * from "./CombinedButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports